export default __webpack_public_path__ + "static/media/snakeImage.71745851.jpg";